export function CloseIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16">
      <path
        d="M14.4776 0.666504L7.99984 7.14428L1.52206 0.666504L1.03317 1.03317L0.666504 1.52206L7.14428
                8.00045L0.666504 14.4782L1.03317 14.9665L1.52206 15.3332L7.99984 8.85539L14.4776 15.3332L14.9665
                14.9665L15.3332 14.4782L8.85539 8.00045L15.3332 1.52206L14.9665 1.03317L14.4776 0.666504Z"
        fill="#000"
      />
    </svg>
  );
}
